import {Button, Type} from '../../../commons/components/button/Button'
import {arPathTrialAccount} from '../../store/ar.paths'

export const ArTestzugangButton = () => {
  return <Button type={Type.INFO} linkTo={arPathTrialAccount()} text="Kostenlosen Testzugang anfordern" />
}
